export default {
  not_found_title: 'No se encontraron resultados',
  not_found_subtitle: 'Intenta modificar o quitar los filtros de búsqueda'
}
